import React from "react";

/**
 * Inline pill for the Workspace header — shows the latest bank certification
 * state for the active period at a glance. Click to open the full report.
 *
 * Statuses map to visual variants:
 *   certified_automatic  → green "Certified"
 *   certified_override   → amber "Certified (Override)"
 *   validation_failed    → red   "Failed"
 *   extraction_failed    → red   "Extract failed"
 *   pending / extracting / validating → grey "Checking…"
 */

const STATUS_VARIANT = {
  certified_automatic: { label: "Certified", cls: "cert-pill-ok" },
  certified_override:  { label: "Override",  cls: "cert-pill-warn" },
  validation_failed:   { label: "Failed",    cls: "cert-pill-bad" },
  extraction_failed:   { label: "Extract failed", cls: "cert-pill-bad" },
  pending:             { label: "Uploaded",  cls: "cert-pill-idle" },
  extracting:          { label: "Extracting…", cls: "cert-pill-idle" },
  validating:          { label: "Validating…", cls: "cert-pill-idle" },
};

export default function BankCertBadge({ cert, onClick }) {
  if (!cert) {
    return (
      <span
        className="cert-pill cert-pill-idle"
        title="No bank statement uploaded for this period yet"
        data-testid="bank-cert-badge-empty"
        onClick={onClick}
        style={{ cursor: onClick ? "pointer" : "default" }}
      >
        Bank statement — not attached
      </span>
    );
  }
  const v = STATUS_VARIANT[cert.status] || { label: cert.status, cls: "cert-pill-idle" };
  const window = cert.statement_period_start && cert.statement_period_end
    ? `${cert.statement_period_start} → ${cert.statement_period_end}` : null;
  return (
    <span
      className={`cert-pill ${v.cls}`}
      data-testid="bank-cert-badge"
      data-status={cert.status}
      onClick={onClick}
      style={{ cursor: onClick ? "pointer" : "default" }}
      title={cert.status === "certified_override"
        ? "Certified by controller override — click for evidence"
        : "Click to open the validation report"}
    >
      <strong>Bank Statement</strong>
      <span className="pill-sep">·</span>
      <span>{v.label}</span>
      {window && <><span className="pill-sep">·</span><span className="mono">{window}</span></>}
      {cert.transaction_count != null && (
        <><span className="pill-sep">·</span><span>{cert.transaction_count} txns</span></>
      )}
      {cert.exception_count > 0 && (
        <><span className="pill-sep">·</span><span>{cert.exception_count} exceptions</span></>
      )}
    </span>
  );
}
